import { withLazy } from 'app/hocs/withLazy'

export const Patients = withLazy(() => import('features/Patients/pages/Patients'))
